import { render } from "./user-settle-trades.vue?vue&type=template&id=77fb02ae"
import script from "./user-settle-trades.vue?vue&type=script&lang=js"
export * from "./user-settle-trades.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__